<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Add New Commodity</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help you when you contact us.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body card-blue">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="category">Category</label>
                                <div class="col-sm-6">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('category')}"
                                                 class="form-control"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :options="categories"
                                                 @search-change="filterCategory"
                                                 data-vv-as="Category"
                                                 placeholder="Search Category"
                                                 id="category"
                                                 name="category"
                                                 v-model="commodity.category"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('category')">{{ errors.first('category') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="name">Commodity Name</label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('name')}"
                                           class="form-control"
                                           data-vv-as="name"
                                           id="name"
                                           name="name"
                                           placeholder="Commodity Name"
                                           type="text"
                                           v-model="commodity.name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('name')">{{ errors.first('name') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="variety">Variety</label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('variety')}"
                                           class="form-control"
                                           data-vv-as="Variety"
                                           id="variety"
                                           name="variety"
                                           placeholder="Goods/Services Variety"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="commodity.variety"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('variety')">{{ errors.first('variety') }}</div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="native">Native Name</label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           data-vv-as="Native"
                                           id="native"
                                           name="native"
                                           placeholder="Goods/Services Native Name"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="commodity.native">
<!--                                    <div class="invalid-feedback" v-if="submitted && errors.has('native')">{{ errors.first('native') }}</div>-->
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="description">Commodity Description</label>
                                <div class="col-sm-6">
                                    <textarea class="form-control"
                                              data-vv-as="description"
                                              id="description"
                                              name="description"
                                              placeholder="Commodity Description"
                                              rows=7
                                              v-model="commodity.description">
                                    </textarea>
<!--                                    <div class="invalid-feedback" v-if="submitted && errors.has('description')">{{ errors.first('description') }}</div>-->
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="code">Commodity Code</label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           data-vv-as="code"
                                           id="code"
                                           name="code"
                                           placeholder="Commodity Code"
                                           type="text"
                                           v-model="commodity.code">
<!--                                    <div class="invalid-feedback" v-if="submitted && errors.has('code')">{{ errors.first('code') }}</div>-->
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="hs_code">HS Code</label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           data-vv-as="hs_code"
                                           id="hs_code"
                                           name="hs_code"
                                           placeholder="HS Code"
                                           type="text"
                                           v-model="commodity.hs_code">
<!--                                    <div class="invalid-feedback" v-if="submitted && errors.has('hs_code')">{{ errors.first('hs_code') }}</div>-->
                                </div>
                                <div class="col-sm-3">
                                    <button class="btn waves-effect waves-light btn-outline-info" data-container="body"
                                            data-content="The HS (Harmonised System) or product code is used by customs officers worldwide to categorise products. See <a href='https://business.gov.nl/running-your-business/international-business/doing-business-abroad/using-the-correct-hs-code' target='_blank'>here for more info</a>"
                                            data-html="true"
                                            data-placement="top"
                                            data-toggle="popover"
                                            title="Harmonised Code"
                                            type="button">
                                        <i class="fas fa-info"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="unit">Quantity Units</label>
                                <div class="col-sm-6">
                                    <div :class="{'is-invalid': submitted && errors.has('unit')}" class="form-control p-0-0">
                                        <unit-select @unit-select="setUnit"
                                                     id="unit"
                                                     name="unit"
                                                     data-vv-as="unit"
                                                     ref="reference"
                                                     v-model="commodity.unit_id"
                                                     v-validate="'required'">
                                        </unit-select>
                                    </div>
                                  <div class="invalid-feedback" v-if="submitted && errors.has('unit')">{{ errors.first('unit') }}</div>
                                    </div>
                            </div>

                            <div class="form-group row" v-bind:key="index" v-for="(row, index) in commodity.props">
                                <label :for="'commodity_id'+index" class="col-sm-3 text-right control-label col-form-label" v-if="index === 0">Commodity Property</label>
                                <label class="col-sm-3" v-if="index > 0"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('propname'+index)}"
                                            :name="'propname'+index"
                                            class="form-control"
                                            data-vv-as="propname"
                                            placeholder="Property Name"
                                            style="height: 42px;"
                                            type="text"
                                            v-model="row.key"
                                            v-validate="''">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('propname'+index)">{{ errors.first('propname'+index) }}</div>
                                </div>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('propval'+index)}"
                                            :name="'propval'+index"
                                            class="form-control"
                                            data-vv-as="propval"
                                            placeholder="Property Description"
                                            style="height: 42px;"
                                            type="text"
                                            v-model="row.value"
                                            v-validate="''">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('propval'+index)">{{ errors.first('propval'+index) }}</div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="form-group button-group">
                                        <button style="height: 40px;" @click="addRow()" class="btn btn-success" type="button" v-if="index === commodity.props.length - 1"><i class="fa fa-plus"></i></button>
                                        <button style="height: 40px;" @click="removeRow(index)" class="btn btn-danger" type="button" v-else><i class="fa fa-minus"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import {mapGetters} from "vuex";
    import UnitSelect from "../../common/UnitSelect";
    import Multiselect from "vue-multiselect";
    import categories from "@/data/commodityCatagories";

    // const categories = [
    //     {
    //         "name": "Others",
    //         "value": "OTHERS"
    //     },
    //     {
    //         "name": "Service",
    //         "value": "SERVICE"
    //     },
    //     {
    //         "name": "Vegetables",
    //         "value": "VEGETABLES"
    //     },
    //     {
    //         "name": "Fruits",
    //         "value": "FRUITS"
    //     },
    //     {
    //         "name": "Dry Fruits",
    //         "value": "DRY_FRUITS"
    //     },
    //     {
    //         "name": "Food Grains",
    //         "value": "FOOD_GRAIN"
    //     },
    //     {
    //         "name": "Pulses",
    //         "value": "PULSES"
    //     },
    //     {
    //         "name": "Processed Items",
    //         "value": "PROCESSED_ITEMS"
    //     },
    //     {
    //         "name": "Spices",
    //         "value": "SPICES"
    //     },
    //     {
    //         "name": "Dairy",
    //         "value": "DAIRY"
    //     },
    //     {
    //         "name": "Edible Oils",
    //         "value": "EDIBLE_OILS"
    //     },
    //     {
    //         "name": "Salt Sugar Jaggery",
    //         "value": "SALT_SUGAR_JAGGERY"
    //     },
    //     {
    //         "name": "Beverages",
    //         "value": "BEVERAGES"
    //     },
    //     {
    //         "name": "Exotic",
    //         "value": "EXOTIC"
    //     },
    //     {
    //         "name": "Non Veg",
    //         "value": "NON_VEG"
    //     },
    //   {
    //     "name": "Hive Products",
    //     "value": "HIVE_PRODUCTS"
    //   }
    // ];

    export default {
        name: "AddCommodity",
        components: {UnitSelect, Multiselect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                categories: [],
                commodity: {
                    name: '',
                    description: '',
                    props: [{
                        key: null,
                        value: null
                    }],
                    code: '',
                    hs_code: '',
                    unit_id: null,
                    variety: null,
                    native: null,
                    category: null,
                },
                file: File,
                filename: "No File Chosen",
                uploadstatus: ''
            };
        },
        mounted() {
            this.$refs.reference.unit = {
                "id": null,
                "name": null,
                "symbol": null,
            };
            Vue.nextTick(function() {
                $('[data-toggle="popover"]').popover({trigger: 'focus'});
            });
        },
        methods: {
            addRow() {
                this.commodity.props.push({
                    key: null,
                    value: null
                });
            },
            removeRow(index) {
                this.commodity.props.splice(index, 1);
            },
            setUnit(e) {
                this.commodity.unit_id = e.id;
            },
            async save() {
                await this.$http.put(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/`, this.commodity);
                this.$router.push({name: "commodities", params: {marketplaceid: this.currentOrg.marketplace_id}});
                this.$toastr('success', 'New commodity has been added successfully.', 'Commodity Added');
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
            },
            reset() {
                this.submitted            = false;
                this.commodity            = {
                    name: '',
                    description: '',
                    code: '',
                    hs_code: '',
                    unit_id: null
                };
                this.$refs.reference.unit = {
                    "id": null,
                    "name": null,
                    "symbol": null,
                }
            },
            filterCategory(search) {
                this.categories = _.filter(categories, (c) => {
                    return c.name.toUpperCase().indexOf(search.toUpperCase()) != -1;
                });
            }
        }
    }
</script>

<style scoped>

</style>
